import { getContext } from '@fiverr-private/fiverr_context';
import { EXPERIMENTS, ALLOCATIONS, ROLLOUTS } from '@fiverr-private/listing_experiments';
import { isEligibleForBookPublishingExperience } from '../../experiments/bookPublishing';

interface UseBookPublishingExperimentProps {
    dominateSubCategoryId: string;
    rollouts: Record<string, boolean>;
}

export const useBookPublishingExperiment = ({ dominateSubCategoryId, rollouts }: UseBookPublishingExperimentProps) => {
    const { abTests } = getContext();
    const isInBookPublishingQuestionnaireTest =
        abTests[EXPERIMENTS.CHEETAHS_BOOK_PUBLISHING] === Number(ALLOCATIONS.TEST_B);
    const isInBookPublishingRollout = Boolean(rollouts?.[ROLLOUTS.CHEETAHS_BOOK_PUBLISHING]);
    const shouldRenderBookPublishingQuestionnaire =
        isInBookPublishingQuestionnaireTest &&
        isInBookPublishingRollout &&
        isEligibleForBookPublishingExperience(Number(dominateSubCategoryId));
    return { shouldRenderBookPublishingQuestionnaire, isInBookPublishingQuestionnaireTest };
};
